(function(){
  if(window.__alinaMq)return;window.__alinaMq=1;
  function init(el){
    if(el.__mq)return;el.__mq=1;
    if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var kids=[].slice.call(el.children);if(kids.length<2)return;
    kids.forEach(function(k){var c=k.cloneNode(true);c.setAttribute('aria-hidden','true');c.removeAttribute('data-shopify-editor-block');c.querySelectorAll('[id]').forEach(function(x){x.removeAttribute('id')});el.appendChild(c);});
    el.style.scrollSnapType='none';
    var first=el.children[0],clone=el.children[kids.length];
    var speed=parseFloat(el.getAttribute('data-marquee'))||0.5;
    var paused=false,t=null,pos=el.scrollLeft,visible=true;
    function loopW(){return clone.offsetLeft-first.offsetLeft}
    function hold(){paused=true;clearTimeout(t);t=setTimeout(function(){paused=false;pos=el.scrollLeft;},2500);}
    ['pointerdown','touchstart','wheel'].forEach(function(e){el.addEventListener(e,hold,{passive:true})});
    el.addEventListener('mouseenter',function(){paused=true;clearTimeout(t)});
    el.addEventListener('mouseleave',function(){paused=false;pos=el.scrollLeft});
    var sec=el.closest('section')||el.parentNode;
    sec.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('[data-prev],[data-next]'))hold();},true);
    if('IntersectionObserver' in window){new IntersectionObserver(function(es){visible=es[0].isIntersecting}).observe(el);}
    function step(){
      var w=loopW();
      if(!paused&&visible&&!document.hidden&&w>0){pos+=speed;if(pos>=w)pos-=w;el.scrollLeft=pos;}
      else{pos=el.scrollLeft;if(w>0&&pos>=w){pos-=w;el.scrollLeft=pos;}}
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function all(){document.querySelectorAll('[data-marquee]').forEach(init)}
  if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',all);
})();
